import React, { useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

const AuthCallback = () => {
    useEffect(() => {
        const handleCallback = async () => {
            // Supabase automatically handles the hash parsing when getSession is called
            // if the URL contains the access_token.
            const { data, error } = await supabase.auth.getSession();

            if (error) {
                console.error('Error during auth callback:', error);
                window.opener.postMessage({ type: 'AUTH_ERROR', error: error.message }, window.location.origin);
                window.close();
                return;
            }

            if (data.session) {
                // Send success message to opener
                if (window.opener) {
                    window.opener.postMessage({ type: 'AUTH_SUCCESS', session: data.session }, window.location.origin);
                }
                // Close the popup
                window.close();
            }
        };

        handleCallback();
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'sans-serif',
            color: '#666'
        }}>
            <p>Completing sign in...</p>
        </div>
    );
};

export default AuthCallback;
